import React, { useState } from 'react';

// Basic styling (can be moved to a CSS file later)
const styles = {
  container: {
    marginTop: '1rem',
    padding: '1rem',
    border: '1px solid #eee',
    borderRadius: '8px',
    backgroundColor: '#fff',
  },
  buttonGroup: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1rem',
    flexWrap: 'wrap', // Allow buttons to wrap on smaller screens
  },
  button: {
    padding: '0.7rem 1.2rem',
    fontSize: '1rem',
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    color: 'white',
  },
  primaryButton: {
    backgroundColor: '#1976d2', // Blue
  },
  secondaryButton: {
    backgroundColor: '#6c757d', // Gray
  },
  finishButton: {
    backgroundColor: '#dc3545', // Red
  },
  disabledButton: {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
  conditionGroup: {
    marginBottom: '1rem',
  },
  conditionLabel: {
    display: 'block',
    marginBottom: '0.5rem',
    fontWeight: 'bold',
    color: '#555',
  },
  radioLabel: {
    marginRight: '1rem',
    cursor: 'pointer',
  },
  radioInput: {
    marginRight: '0.3rem',
  }
};

const QRScanActionButtons = ({ isUsing, onStartUsage, onEndUsage, onShowSOP, loading }) => {
  // Default condition is 'Baik'
  const [condition, setCondition] = useState('Baik');

  const handleActionClick = () => {
    if (loading) return; // Prevent action if already loading

    if (isUsing) {
      onEndUsage(condition);
    } else {
      onStartUsage(condition);
    }
  };

  const conditionText = isUsing ? 'Kondisi Alat Setelah Digunakan:' : 'Kondisi Alat Saat Ini:';

  return (
    <div style={styles.container}>
      {/* Condition Selection */}
      <div style={styles.conditionGroup}>
        <label style={styles.conditionLabel}>{conditionText}</label>
        <div>
          <label style={styles.radioLabel}>
            <input
              type="radio"
              name="condition"
              value="Baik"
              checked={condition === 'Baik'}
              onChange={(e) => setCondition(e.target.value)}
              disabled={loading}
              style={styles.radioInput}
            />
            Baik
          </label>
          <label style={styles.radioLabel}>
            <input
              type="radio"
              name="condition"
              value="Rusak"
              checked={condition === 'Rusak'}
              onChange={(e) => setCondition(e.target.value)}
              disabled={loading}
              style={styles.radioInput}
            />
            Rusak
          </label>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={styles.buttonGroup}>
        <button
          onClick={handleActionClick}
          disabled={loading}
          style={{
            ...styles.button,
            ...(isUsing ? styles.finishButton : styles.primaryButton),
            ...(loading ? styles.disabledButton : {})
          }}
        >
          {loading ? 'Memproses...' : (isUsing ? 'Selesai Menggunakan' : 'Gunakan Alat')}
        </button>

        {/* Show SOP button is always available (unless loading) */}
        <button
          onClick={onShowSOP}
          disabled={loading}
          style={{
            ...styles.button,
            ...styles.secondaryButton,
            ...(loading ? styles.disabledButton : {})
          }}
        >
          Lihat SOP
        </button>
      </div>
    </div>
  );
};

export default QRScanActionButtons;
